import './jsonFormatter.css'; // Import a separate CSS file for this component

import React, { useState } from 'react';

function RegexTester() {
  const [pattern, setPattern] = useState('');
  const [text, setText] = useState('');
  const [result, setResult] = useState('');

  const testRegex = () => {
    try {
      const regex = new RegExp(pattern);
      setResult(text.match(regex) ? 'Match Found' : 'No Match');
    } catch (error) {
      setResult('Invalid Regex');
    }
  };

  return (
    <div className="encoder-decoder"  id="RegexTester">
      <h2>Regex Tester</h2>
       <div className="description-section">
           <p>
The Regex Tester is a practical tool for working with regular expressions. This component allows users to input a regular expression pattern and test it against a sample string, verifying matches instantly. It’s ideal for those needing to validate email formats, extract specific text from strings, or apply complex search patterns. As an essential utility, the Regex Tester provides a sandbox for fine-tuning regex patterns without needing to run them in production.

        </p>
          </div>
      <input className = "output-text" type="text" placeholder="Enter Regex" value={pattern} onChange={(e) => setPattern(e.target.value)} />
      <input className = "output-text"  type="text" placeholder="Enter Text" value={text} onChange={(e) => setText(e.target.value)} />
      <button className="beautify-button" onClick={testRegex}>Test Regex</button>
      <p>{result}</p>
    </div>
  );
}

export default RegexTester;
